// --------- 公用的 ---------
export default {
  // 表单相关
  formAbout: {
    // ----搜索相关 Start
    search: '搜索...',
    ordinarySearch: '普通搜索',
    advancedSearch: '高级搜索',
    searchBtn: '搜索',
    clear: '清空',
    all: '全部',
    customizeFields: '自定义显示字段',
    export: '导出',
    rename: '重命名',
    // ----报表相关
    today: '今天',
    yesterday: '昨天',
    thisWeek: '本周',
    lastWeek: '上周',
    thisMonth: '本月',
    lastMonth: '上月',
    interval: '间隔',
    auto: '自动',
    // ----搜索相关 End
    /* ----------------------------- */
    // ----Modal相关 Start
    ok: '确认',
    cancel: '取消',
    modal: {
      detail: '详情'
    },
    // ----Modal相关 End
    /* ----------------------------- */
    // 机器人与设计器 --Start
    robotName: '机器人名称',
    userStatus: '使用状态',
    expireDate: '到 期 时 间',
    createdDate: '创建时间',
    // 机器人与设计器 --End
    /* ----------------------------- */
    // 流程管理 --Start
    proName: '流程名称',
    pushTime: '发布日期',
    desc: '描述',
    // 流程管理 --End
    /* ----------------------------- */
    // ----任务管理相关 Start
    robot: '机器人',
    robotSelectTip: '亲，你已经选择所有机器人啦 ~',
    procName: '流程名',
    taskStatus: '状态',
    taskTime: '任务时间',
    taskStartT: '任务开始时间',
    taskEndT: '任务结束时间',
    // ----任务管理相关 End
    /* ----------------------------- */
    // ----变量管理相关 Start
    variate: {
      name: '变量名',
      namePlaceH: '请输入变量名',
      nameVMsg: '变量名长度需为2-64个字符，请确认！',
      value: '变量值',
      valuePlaceH: '请输入变量值',
      valueVMsg: '变量值长度需为1-128个字符，请确认！',
      type: '变量类型',
      typeV: {
        common: '普通类型',
        password: '密码类型'
      },
      description: '变量描述',
      descVMsg: '变量描述长度需为0-100个字符，请确认！',
      descriptionPlaceH: '请输入变量描述...',
      robot: '机器人',
      robotVMsg: '请选择机器人',
      isClientEdit: '客户端修改',
      isPythonExpr: '保存Python表达式'
    },
    // ----变量管理相关 End
    /* ----------------------------- */
    // ----任务数据相关 Start
    taskData: {
      name: '空间名',
      namePlaceH: '请输入空间名',
      nameVMsg: '空间名长度需为2-64个字符，请确认！',
      failTryTimes: '失败尝试次数',
      failTryTimesPlaceH: '请输入最大失败尝试次数',
      failTryTimesVMsg: '最大失败尝试次数最高为99999次，请确认',
      queueMaxItems: '空间项最大数',
      queueMaxItemsPlaceH: '请输入空间项最大数',
      queueMaxItemsVMsg: '空间项最大数在1至10000之间，请确认',
      description: '空间描述',
      failqueueDescVMsg: '空间描述长度需为0-128个字符，请确认！',
      descriptionPlaceH: '请输入空间描述...',
      robot: '机器人',
      robotVMsg: '请选择机器人'
    }
    // ----任务数据相关 End
  },
  // 操作
  operation: {
    play: '播放',
    deleteCurCol: '删除当前列',
    curColTurnLeft: '当前列左移',
    curColTurnRight: '当前列右移',
    tableOperation: '操作',
    notAvailable: '暂无',
    btnAdd: '新增',
    btnDel: '删除',
    btnView: '查看',
    btnMod: '修改',
    save: '保存',
    // 分页 --Start
    total: '共有',
    items: '条',
    totalRecords: '共有 {total} 条',
    // 分页 --End
    // 机器人与设计器 --Start
    renew: '续费',
    expend: '免费延长30天',
    monitor: '监控',
    lookTask: '查看任务',
    tip: '提示',
    ok: '确认',
    cancel: '取消',
    // 机器人与设计器 --End
    /* ----------------------------- */
    // 流程管理 --Start
    task: '任务',
    sure: '保存',
    backList: '返回流程列表',
    curTask: '临时任务',
    editBtn: '编辑',
    downBtn: '下载',
    executeImmediately: '立即执行',
    whetherExecuteImm: '是否立即执行？',
    // 流程管理 --End
    /* ----------------------------- */
    /* ----------------------------- */
    // ----变量管理相关 Start
    viewAccessRecord: '查看访问记录',
    variateModify: '修改',
    variateDel: '删除',
    // ----变量管理相关 End
    /* ----------------------------- */
    // ----任务数据相关 Start
    clearRecord: '清空记录',
    viewData: '查看数据',
    // 查看数据
    viewDetails: '查看详情',
    viewLogs: '查看日志'
    // ----任务数据相关 End
  },
  // 提示消息
  msg: {
    canceled: '已取消',
    delSuceess: '删除成功',
    addSuceess: '新增成功',
    uploadSucess: '上传成功',
    proStateSucess: '流程状态修改成功',
    modifyOk: '修改成功',
    extendOk: '延长成功',
    clearOk: '清除成功',
    outErr: '请求超时，请稍后再试',
    bindOk: '解绑成功',
    success: '操作成功',
    printMag: '正在加载中，请稍后...',
    payOrder: '正在创建支付订单，请勿频繁操作...'
  },
  notice: {
    widtdrawal: {
      title: '停服公告',
      content: {
        0: '尊敬的用户：',
        1: '我们很抱歉地通知您，我们将停止对i-Search Cloud老版本的支持和服务，并于2023年12月31日正式关闭i-Search Cloud老版本平台。',
        2: '我们深知老版本对您的工作和业务产生了重要影响，因此我们制定了一份升级计划，自2023年7月1日0时至2023年12月31日24时分批次面向用户开启迁移服务，2024年1月1日24时将截止迁移服务，届时，i-Search Cloud老版本平台将正式关停，用户无法再登录平台。',
        3: '我们对给您带来的不便表示歉意。如果您对升级过程有任何疑问或需要技术支持，请联系我们的客户服务团队：请拨打 {phone}。我们的专业人员将竭诚为您提供帮助，并确保您顺利完成升级过程。',
        4: 'i-Search Cloud平台已升级至最新版本，您也可直接访问：{link}进行申请试用！',
        5: '感谢您一直以来对我们的支持！期待与您在新的起点上再度相见。',
        6: '此致',
        7: '艺赛旗团队敬上'
      },
      action: {
        ok: '我知道了'
      }
    }
  }
}
